import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../assets/logo.png";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      {/* LEFT: Social icons */}
      <div className="footer-left">
        <nav aria-label="Social links" className="social">
          <a
            href="https://twitter.com/"
            target="_blank"
            rel="noreferrer"
            aria-label="X / Twitter"
            title="X / Twitter"
            className="social-btn"
          >
            {/* X icon */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M18.244 2H21l-6.54 7.48L22 22h-6.955l-4.58-6.088L4.98 22H2.223l7.08-8.09L2 2h7.03l4.17 5.64L18.244 2Zm-1.23 18h2.037L8.083 4H6.02l11 16Z" />
            </svg>
          </a>

          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
            className="social-btn"
          >
            {/* LinkedIn icon */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5ZM.24 8.01h4.52V24H.24V8.01ZM8.64 8.01h4.33v2.18h.06c.6-1.13 2.06-2.33 4.24-2.33 4.54 0 5.38 2.99 5.38 6.87V24H18.3v-7.3c0-1.74-.03-3.98-2.43-3.98-2.43 0-2.8 1.9-2.8 3.86V24H8.64V8.01Z" />
            </svg>
          </a>

          <a
            href="https://github.com/"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            title="GitHub"
            className="social-btn"
          >
            {/* GitHub icon */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 .5A11.5 11.5 0 0 0 .5 12.2c0 5.19 3.37 9.59 8.05 11.15.59.11.8-.26.8-.57 0-.28-.01-1.02-.02-2-3.27.72-3.96-1.6-3.96-1.6-.54-1.4-1.32-1.78-1.32-1.78-1.08-.75.08-.74.08-.74 1.2.09 1.83 1.25 1.83 1.25 1.06 1.86 2.78 1.32 3.46 1.01.11-.79.41-1.32.75-1.62-2.61-.31-5.36-1.35-5.36-6.01 0-1.33.46-2.41 1.22-3.26-.12-.3-.53-1.55.12-3.23 0 0 .99-.32 3.25 1.24a11.1 11.1 0 0 1 2.96-.41c1 .01 2.01.14 2.96.41 2.25-1.56 3.24-1.24 3.24-1.24.66 1.68.25 2.93.13 3.23.76.85 1.21 1.93 1.21 3.26 0 4.68-2.75 5.7-5.37 6 .42.37.8 1.1.8 2.22 0 1.61-.02 2.9-.02 3.29 0 .31.2.68.81.57A11.51 11.51 0 0 0 23.5 12.2 11.5 11.5 0 0 0 12 .5Z" />
            </svg>
          </a>
        </nav>
      </div>

      {/* RIGHT: Content */}
      <div className="footer-right">
        <div className="brand-row">
          <div className="brand-box">
            <img src={logo} alt="Company Logo" className="logo-img" />
          </div>
          <div className="brand-title"></div>
        </div>

        <div className="links">
          <div className="col">
            <h4>{t('about_title', 'About')}</h4>
            <Link to="/about">{t('about_link', 'About')}</Link>
            <Link to="/contact">{t('contact_us', 'Contact Us')}</Link>
          </div>

          <div className="col">
            <h4>{t('references_title', 'References')}</h4>
      <Link to="/legal">{t('privacy_policy', 'Privacy Policy')}</Link>
<Link to="/terms">{t('terms_of_service', 'Terms of Service')}</Link>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} HW AI. {t('all_rights_reserved', 'All rights reserved.')}.
        </div>
      </div>
    </footer>
  );
}